import { datadogRum } from '@datadog/browser-rum';
import { analytics } from '@modules/analytics';
import type { CookieConsentCategories } from '@modules/cookie-utils';
import { useEffect } from 'react';

/** Extend this to handle other performance based cookies from tools that we use. */
const handlePerformanceCookiesConsent = (
  accepted: CookieConsentCategories[],
  rejected: CookieConsentCategories[],
) => {
  if (accepted.includes('performance')) {
    datadogRum.setTrackingConsent('granted');
  }

  if (rejected.includes('performance')) {
    datadogRum.setTrackingConsent('not-granted');
  }
};

/** Extend this to handle other analytics based cookies from tools that we use. */
const handleAnalyticsCookies = (accepted: CookieConsentCategories[]) => {
  if (accepted.includes('analytics')) {
    analytics.initialize();
  }
};

const handleAdvertisingConsent = (accepted: CookieConsentCategories[]) => {
  if (accepted.includes('advertisement')) {
    window.fbq?.('consent', 'grant');
    window.uetq?.push('consent', 'update', { ad_storage: 'granted' });
  } else {
    window.fbq?.('consent', 'revoke');
    window.uetq?.push('consent', 'update', { ad_storage: 'denied' });
  }
};

const handleCookieConsent = (
  event: CustomEvent<{
    accepted: CookieConsentCategories[];
    rejected: CookieConsentCategories[];
  }>,
) => {
  const { accepted, rejected } = event.detail;

  handlePerformanceCookiesConsent(accepted, rejected);
  handleAnalyticsCookies(accepted);
  handleAdvertisingConsent(accepted);
};

export const useCookieConsentListener = (): void => {
  useEffect(() => {
    document.addEventListener('cookieyes_consent_update', handleCookieConsent as EventListener);

    return () => {
      document.removeEventListener(
        'cookieyes_consent_update',
        handleCookieConsent as EventListener,
      );
    };
  }, []);
};
